import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVolumeMute, faVolumeUp } from '@fortawesome/free-solid-svg-icons'
import React, { useState, useEffect, useRef } from 'react'

const AudioControls = () => {
  const [isMuted, setIsMuted] = useState(false)
  const [volume, setVolume] = useState(1)
  const [showSlider, setShowSlider] = useState(false)
  const hideTimeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    const mediaElement = document.querySelector('video, audio') as HTMLMediaElement
    if (mediaElement) {
      setIsMuted(mediaElement.muted)
      setVolume(mediaElement.volume)
    }
  }, [])

  const toggleMute = () => {
    const newMuteState = !isMuted
    setIsMuted(newMuteState)

    document.querySelectorAll('video, audio').forEach((mediaElement) => {
      if (mediaElement instanceof HTMLMediaElement) {
        mediaElement.muted = newMuteState
        if (!newMuteState) {
          mediaElement.volume = volume
          mediaElement.play().catch((err) => console.warn('Autoplay prevented:', err))
        }
      }
    })
  }

  const changeVolume = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newVolume = parseFloat(e.target.value)
    setVolume(newVolume)

    document.querySelectorAll('video, audio').forEach((mediaElement) => {
      if (mediaElement instanceof HTMLMediaElement) {
        mediaElement.volume = newVolume
        if (newVolume > 0) {
          mediaElement.muted = false
          setIsMuted(false)
        }
      }
    })
  }

  const showVolumeSlider = () => {
    setShowSlider(true)
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current)
    }
    hideTimeoutRef.current = setTimeout(() => {
      setShowSlider(false)
    }, 3000)
  }

  return (
    <div className="relative flex items-center">
      <div className="relative group" onMouseEnter={showVolumeSlider}>
        {!isMuted && showSlider && (
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={volume}
            onChange={changeVolume}
            className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-14 h-2 cursor-pointer"
          />
        )}

        <button
          onClick={toggleMute}
          className="flex items-center justify-center rounded-full border bg-gray-300 w-10 h-10"
          aria-label="Toggle Audio"
        >
          <FontAwesomeIcon icon={isMuted ? faVolumeMute : faVolumeUp} />
        </button>
      </div>
    </div>
  )
}
export default AudioControls
